import { isProd } from './Common'

// Tracking Tokens
export const MIXPANEL_TOKEN = isProd ? '3c244ee8c15c7d6398823f36eb9a29f1' : '7965f69fd102dc556a406040b6286913'
export const BRANCHIO_TOKEN = 'key_live_itmfGCzFIkozguMBi6NYKheptvc9XOAR'
export const PLATFORM = 'web'

export const PAYMENT_FLOW_EVENTS = {
  PAYMENT_STARTED: 'Payment Started',
  PAYMENT_ABORTED: 'Payment Aborted',
  PAYMENT_FAILED: 'Payment Failed',
  PAYMENT_NOOP: 'Payment Not Needed',
  PAYMENT_COMPLETED_SUCCESS: 'Payment Completed Successfully',
  PAYMENT_COMPLETED_ERROR: 'Payment Completed With Error',
} as const

// Used as extra metadata in some mixpanel tracking events
export const PAGE_NAMES = {
  // Page name constants
  LOGIN: 'Login',
  PARTNER_LOGIN: 'Partner Login',
  PARTNER_SIGNUP: 'Partner Signup',
  ADD_CLUB_MATCH: 'Add Club Match',
  ADD_MATCH: 'Add a Match',
  SIGN_UP: 'Sign Up',
  SIGN_UP_STEP1: 'Sign Up [Step 1] (Account details)',
  SIGN_UP_STEP2: 'Sign Up [Step 2] (Create password)',
  CLUB_HOME: 'Club Home',
  BROWSE_CLUBS: 'Browse Clubs',
  BROWSE_EVENTS: 'Browse Events',
  BROWSE_PLAYERS: 'Browse Players',

  // Navigation
  MEMBER_TAB: 'Member Tab',
} as const

export const TRACKING_TYPES = {
  SIGN_UP_REGISTER: 'Sign Up Register Clicked',
  SIGN_UP_SUCCESS: 'Signup Success',
  SIGN_UP_ERROR: 'Signup Error',
  SIGN_IN: 'Login Success',
  SIGN_IN_ERROR: 'Login Error',
  PARTNER_LOGIN_SUCCESS: 'Partner Login Success',
  PARTNER_LOGIN_ERROR: 'Partner Login Error',
  CONNECTED_ACCOUNT: 'Connected Account',
  PARTNER_SIGNUP_SUCCESS: 'Partner Signup (Account details) Success',
  PARTNER_SIGNUP_SUCCESS_PASSWORD: 'Partner Signup (Password) Success',
  PARTNER_SIGNUP_ERROR: 'Partner Signup Error',
  FORGOT_PASSWORD: 'Forgot Password',
  VERIFY_PHONE: 'Verify Phone',
  VERIFY_PHONE_ERROR: 'Verify Phone Error',
  VERIFY_EMAIL: 'Verify Email',
  OPEN_PLAYER_PROFILE: 'Open Player Profile',
  OPEN_MATCH_HISTORY: 'Open Match History',
  RESET_PASSWORD: 'Reset Password',
  SUPPORT: 'Support',
  HOW_IT_WORKS: 'How It Works',
  PRIVACY_POLICY: 'PrivacyPolicy',
  TERMS: 'Terms',
  ADD_BRACKET: 'Add Bracket',
  ADD_A_BRACKET: 'Add a Bracket',
  ADD_EVENT: 'Add Event',
  SETUP_PAYMENTS: 'Setup Payments',
  SEED_BRACKET: 'Seed Bracket',
  CREATE_LEAGUE: 'Create League',
  EDIT_EVENT: 'Edit Event',
  END_EVENT: 'End Event',
  EDIT_BRACKET: 'Edit Bracket',
  END_BRACKET: 'End Bracket',
  LEAGUE_SUMMARY: 'League Summary',
  USER_VERIFICATION: 'User Verification',
  DASHBOARD: 'Dashboard',
  LANDING_PAGE: 'Landing Page',
  LIFETIME_PAGE: 'Lifetime Page',
  LEAGUE_REGISTER: 'League Register',
  USER_DASHBOARD: 'User Dashboard',
  MATCH_HISTORY: 'Match History',
  ADD_CLUB_MEMBER: 'Add Club Member',
  ADD_CLUB_MEMBER_CSV: 'Invite Members by CSV',
  MY_BRACKETS: 'Browse All Brackets',
  MY_BRACKET: 'My Brackets',
  MY_EVENTS: 'My Events',
  MY_MATCHES: 'My Matches',
  USER_MATCH_ADDED: 'User Match Added',
  CLUB_MATCH_ADDED: 'Club Match Added',
  MY_CLUBS: 'My Clubs',
  EVENT_HOME: 'Event Home',
  EVENT_LOGO: 'Event Logo',
  CHANGE_LOGO: 'Change Logo',
  REMOVE_LOGO: 'Remove Logo',
  BRACKET_HOME: 'Bracket Home',
  EDIT_PROFILE: 'Edit Profile',
  SEARCH_PLAYERS: 'Search Players',
  PLAYER_PROFILE: 'Player Profile',
  ADD_ANNOUNCEMENT: 'Add Announcements',
  ADD_AN_ANNOUNCEMENT: 'Add an Announcement',
  EDIT_ANNOUNCEMENT: 'Edit Announcement',
  CLAIM_ACCOUNT: 'Claim Account',
  ADD_PROFILE_PICTURE: 'Add Profile Picture',
  CHANGE_PROFILE_PICTURE: 'Change Profile Picture',
  REMOVE_PROFILE_PICTURE: 'Remove Profile Picture',
  USER_PROFILE: 'User Profile',
  CLAIM_YOUR_ACCOUNT: 'Claim Your Account',
  CREATE_AN_ACCOUNT: 'Create An Account',
  MATCH_ADDED: 'Match Added ',
  ADD_CLUB_MATCH_SUCCESS: 'Add Club Match Success',
  ADD_EVENT_SUCCESS: 'Add Event Success',
  SEARCH_PERFORMED: 'Search Performed',
  REMOVE_PARTNER: 'Partner Removed',
  SHARE_DONE: 'Share Done',
  MOBILE_SIGN_UP_SPLASH: 'Mobile Sign Up Splash',
  DOWNLOAD_APPLE_APP: 'Download Apple App Store Clicked',
  DOWNLOAD_ANDROID_APP: 'Download Android Play Store Clicked',
  HARD_SIGNUP_SUBSCRIBE_PAYWALL: 'Hard Sign Up Subscribe Paywall',
  UPDATED_TOS_ACCEPTED: 'Accepted Updated TOS',
  UPGRADE_CTA_CLICKED: 'Upgrade CTA Clicked',
  // The DUPR+ attribution funnel, shared with the mobile app: a tagged (utm_*) link opened, and
  // the purchase it led to, both carrying the campaign. The purchase event fires beside the
  // legacy payment events, which stay for existing reports.
  CAMPAIGN_LINK_OPENED: 'Campaign Link Opened',
  PURCHASE_COMPLETED: 'Purchase Completed',

  // View names constants
  FILTER: 'Filter',
  PROFILE_TAB: 'Profile Tab',
  SECURITY_TAB: 'Security Tab',
  NOTIFICATION_TAB: 'Notification Tab',
  APPLY_FILTER: 'Apply Filter',
  CLEAR_FILTER: 'Clear Filter',
  SORT: 'Sort',
  MATCH_VALIDATED: 'Match Validated',
  MATCH_DELETED: 'Match Deleted',
  JOIN_CLUB: 'Join Club',
  LEAVE_CLUB: 'Leave Club',
  CHAT: 'Chat',
  PLAYERS_NEAR_ME: 'Players Near Me',
  INVITE_PLAYER: 'Invite A Player',
  PLAYER_CARD: 'Player Card',
  BACK_BUTTON: 'Back',
  SAVE_BUTTON: 'Save',
  UPDATE_NAME: 'Update Name',
  OPEN_NAME_POPUP: 'Open Name Popup',
  CLOSE_NAME_POPUP: 'Close Name Popup',
  REGISTER: 'Register',
  SUBMIT_PAYMENT: 'Submit Payment',
  VIEW_PROFILE: 'View  Profile',
  PROFILE_URL: 'Copy Profile Url',
  WITHDRAW: 'Withdraw',
  WITHDRAW_REFUND_UNMATCHED_PLAYERS: 'Withdraw/Refund (Unmatched Players Tab)',
  VIEW_DRAW: 'View Visual Diagram(View Draw)',
  VB_DIAGRAM: 'VB Diagram',
  PARTNER_ADDED: 'Partner Added',
  PARTNER_REMOVED: 'Partner Removed',
  REQUEST_ACCEPT: 'Request Accepted',
  REQUEST_DECLINE: 'Request Rejected',
  ADD_SCORES: 'Add Scores',
  MATCHES_TAB: 'Match Tab',
  SHARE: 'Share',
  FINISH: 'Finish',
  CLAIM_SUCCESSFUL: 'Claim Successful',
  SEED_MATCHES: 'Seed Matches',
  CONFIRM_TEAM: 'Confirm Team',
  EDIT_TEAM: 'Edit Team',
  SPLIT_TEAM: 'Split Team',
  CREATE_TEAM: 'Create Team',
  PLAYER_TAB: 'Player Tab',
  CLUB_SHARE: 'Club Share',
  EVENT_SHARE: 'Event Share',
  PROFILE_SHARE: 'Profile Share',
  BRACKET_SHARE: 'Bracket Share',
  EXIT_EVENT: 'Exit Event',
  ...PAYMENT_FLOW_EVENTS,
  ...PAGE_NAMES,
} as const

// Options
export const ratingOptions = [
  { key: 'DESC', value: 'High to Low Rating' },
  { key: 'ASC', value: 'Low to High Rating' },
]

export const eventStatus = {
  registrationClose: 'Registration close',
  completed: 'Completed',
  upComing: 'Upcoming',
  onGoing: 'Ongoing',
  open: 'Open',
}

// This is a helper type that gets the value types of an object.
type ObjectValues<T> = T[keyof T]

// This is our new, automatically generated, and always up-to-date type for tracking events
// It will be a union of: 'Login' | 'Sign Up' | 'Sign Up [Step 1]' | etc.
export type TrackingEventName = ObjectValues<typeof TRACKING_TYPES>
export type PaymentFlowEventTypes = ObjectValues<typeof PAYMENT_FLOW_EVENTS>
